import React, { useEffect, useState } from "react";
import API from "./api";

export default function BookSection() {
  const [books, setBooks] = useState([]);
  const [borrows, setBorrows] = useState({});
  const [form, setForm] = useState({ title: "", author: "" });
  const [error, setError] = useState("");

  // 1) Load books & active borrow records
  useEffect(() => {
    async function loadData() {
      try {
        const booksRes = await API.get("/books");
        setBooks(booksRes.data);

        const borrowsRes = await API.get("/borrow/active");
        const map = {};
        borrowsRes.data.forEach(rec => { map[rec.book.id] = rec; });
        setBorrows(map);
      } catch (err) {
        setError(err.response?.data || err.message);
      }
    }
    loadData();
  }, []);

  // 2) Add a new book, then reload
  const handleAdd = async () => {
    if (!form.title || !form.author) return alert("Both fields required");
    if (!window.confirm(`Add book "${form.title}"?`)) return;
    try {
      await API.post("/books", form);
      setForm({ title: "", author: "" });
      // reload data
      const booksRes = await API.get("/books");
      setBooks(booksRes.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  // 3) Delete a book, then reload
  const handleDelete = async (id) => {
    if (!window.confirm(`Delete book #${id}?`)) return;
    try {
      await API.delete(`/books/${id}`);
      const booksRes = await API.get("/books");
      setBooks(booksRes.data);
     } catch (err) {
      const apiErr = err.response?.data?.message || JSON.stringify(err.response?.data); 
      setError(apiErr || err.message);
    }
  };

  // 4) Borrow or return based on current state, then reload
  const handleToggle = async (bookId) => {
    const br = borrows[bookId];
    if (br) {
      if (!window.confirm(`Return book #${bookId}?`)) return;
      try {
        await API.post(`/borrow/return?bookId=${bookId}`);
      } catch (err) {
        return setError(err.response?.data || err.message);
      }
    } else {
      const userId = prompt("Enter user ID to borrow:");
      if (!userId || !window.confirm(`Borrow book #${bookId} to user ${userId}?`)) return;
      try {
        await API.post(`/borrow?userId=${userId}&bookId=${bookId}`);
      } catch (err) {
        return setError(err.response?.data || err.message);
      }
    }
    // reload both lists after action
    const [booksRes, borrowsRes] = await Promise.all([
      API.get("/books"),
      API.get("/borrow/active")
    ]);
    setBooks(booksRes.data);
    const map = {};
    borrowsRes.data.forEach(rec => { map[rec.book.id] = rec; });
    setBorrows(map);
  };

  return (
    <div style={sectionStyle}>
      <h3>Book Catalog</h3>
      {error && <div style={errorStyle}>{error}</div>}

      <div style={formRow}>
        <input
          placeholder="Title"
          value={form.title}
          onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
        />
        <input
          placeholder="Author"
          value={form.author}
          onChange={e => setForm(f => ({ ...f, author: e.target.value }))}
        />
        <button onClick={handleAdd}>Add Book</button>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th>ID</th><th>Title</th><th>Author</th>
            <th>Status</th><th>Borrowed By</th><th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {books.map(b => {
            const br = borrows[b.id];
            return (
              <tr key={b.id}>
                <td>{b.id}</td>
                <td>{b.title}</td>
                <td>{b.author}</td>
                <td>{b.available ? "Available" : "Borrowed"}</td>
                <td>{br ? br.user.id : "-"}</td>
                <td>
                  <button onClick={() => handleToggle(b.id)}>
                    {b.available ? "Borrow" : "Return"}
                  </button>
                  <button onClick={() => handleDelete(b.id)} style={{ marginLeft: 8 }}>
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

const sectionStyle = {
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: 12,
  marginBottom: 20,
  background: "#f9f9f9"
};
const formRow = { display: "flex", gap: "8px", marginBottom: "12px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const errorStyle = { color: "red", marginBottom: "8px" };
